import { Navigate, useLocation } from 'react-router-dom';
import { SALON_GUEST_INTENT_PATH } from '../config/salonApp';

/** Legacy URL — guest confirm is merged into guest-intent. */
export default function GuestConfirmCheckinPage() {
  const location = useLocation();
  return <Navigate to={SALON_GUEST_INTENT_PATH} replace state={location.state} />;
}
